import { useState ,useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import './skillsHandler.css'
import axios from 'axios';
import Nav from '../nav_home_out/nav_home_out'

const url = "https://personal-portfolio-theta-blue.vercel.app/addskill"

function SkillHandler() {
  const logout= useNavigate();
  const [skillstate, setskillstate] = useState( { skill:"",experience:""})

  useEffect(()=>{
    if(localStorage.getItem('auth')=='false' || localStorage.getItem('auth')==null){
      logout('/admin')
    }
  },[])

  const addSkill = async (skillstate) => {
    try{
      await axios.post(url, skillstate)
    }catch(error){
      console.log(error)
    }
    window.location.reload()
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    addSkill(skillstate)
  }

  const handleSkill=async(e)=>{
    const skillname=e.target.value;
    setskillstate({ ...skillstate, skill : skillname })
  }
  const handleExplevel=async(e)=>{
    const explevel=e.target.value;
    setskillstate({ ...skillstate, experience : explevel })
  }

  return (
    <div className="SkillUpload">
      <form onSubmit={handleSubmit} className='SkillUploadForm'>
        <h1>Add Skill</h1>
        <input 
          type="text"
          name="skill"
          id='skill'
          required
          placeholder='Enter Skill Name'
          onChange={(e)=>handleSkill(e)}
         />
         <input type='text' name='experience' required id='experience' onChange={(e)=>handleExplevel(e)} placeholder='Enter Experience Level'/>
         <button type='submit' className='btn btn-primary'>Submit</button>
      </form>
      <Nav/>
    </div>
  )
}

export default SkillHandler